import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { UserCircle, Circle } from '@phosphor-icons/react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function HandlerStatus() {
  const [handlers, setHandlers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHandlerStatus();
    const interval = setInterval(fetchHandlerStatus, 5000);
    return () => clearInterval(interval);
  }, []);



  const fetchHandlerStatus = async () => {
    try {
      const response = await axios.get(`${API}/users/handlers`);
      setHandlers(response.data?.handlers || response.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getRoleLabel = (role) => {
    return role?.replace('_handler', ' Handler').replace(/^\w/, (c) => c.toUpperCase());
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="flex items-center gap-3 mb-6 border-b pb-3">
        <UserCircle size={28} className="text-blue-500" />
        <div>
          <h2 className="text-xl font-bold text-gray-800">Handler Status</h2>
          <p className="text-sm text-gray-500">Monitor real-time online status and activity of support operators</p>
        </div>
      </div>

      {loading ? (
        <p className="text-gray-500 text-center py-6">Loading handler status...</p>
      ) : (
        <div className="divide-y max-h-[500px] overflow-y-auto">
          {handlers.map((handler) => (
            <div key={handler.id} className="py-4 flex items-center justify-between">
              <div>
                <h3 className="font-semibold text-gray-800">{handler.username}</h3>
                <p className="text-xs text-gray-500">{getRoleLabel(handler.role)}</p>
                <p className="text-xs text-gray-400 mt-1">
                  Last Active: {handler.last_seen ? new Date(handler.last_seen).toLocaleString('en-IN') : 'Never'}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Circle
                  size={12}
                  weight="fill"
                  className={handler.is_online ? 'text-green-500 animate-pulse' : 'text-gray-400'}
                />
                <span className="text-sm font-medium text-gray-600">
                  {handler.is_online ? 'Online' : 'Offline'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
